// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__vcNDC App_paper__8CPy4"};